var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#5EA2FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.771 2.038c-.808.134-1.549.856-1.721 1.679-.073.35-.073 12.216 0 12.566a2.232 2.232 0 0 0 1.15 1.479c.515.253.055.237 6.8.237s6.285.016 6.8-.237a2.232 2.232 0 0 0 1.15-1.479c.041-.195.049-.738.049-3.311.001-3.459.018-3.234-.248-3.39a.612.612 0 0 0-.247-.082.604.604 0 0 0-.424.223c-.061.09-.064.217-.08 3.244l-.017 3.151-.108.221a1.145 1.145 0 0 1-.571.556l-.187.088H3.882l-.221-.108a1.141 1.141 0 0 1-.556-.571l-.088-.187V3.882l.108-.221c.127-.257.307-.433.571-.556l.187-.088L8.7 3l4.817-.017.104-.074a.49.49 0 0 0-.037-.827L13.444 2l-4.747.004c-2.611.002-4.828.017-4.926.034m14.329.865c-.064.038-1.913 1.864-4.108 4.058l-3.991 3.988-1.092-1.087C8.308 9.263 7.769 8.75 7.71 8.72c-.151-.076-.299-.066-.461.029a.478.478 0 0 0-.198.631c.027.058.646.701 1.375 1.427 1.433 1.43 1.395 1.399 1.699 1.344.111-.02.585-.482 4.367-4.261 2.333-2.332 4.264-4.287 4.291-4.345a.477.477 0 0 0-.199-.629c-.171-.101-.329-.105-.484-.013",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon-checkbox.87344bf7f2b35b1d9ac409b4760d4413.svg";
export { ForwardRef as ReactComponent };